(function() { window.GUID_3d037176_f485_4275_8395_3c8574f3f151 = { getGuid: function() { return "3d037176-f485-4275-8395-3c8574f3f151"; } }; })();
var CS;
(function (CS) {
    var Views;
    (function (Views) {
        var NativeApp;
        (function (NativeApp) {
            class SelectEventForHelp extends Views.ViewBase {
                OnDispose() {
                }
                constructor() {
                    super();
                    let me = this;
                    if ($('#btn-no').length == 0) {
                        $('#cs-event-dropdown-event-drpdwn-help').click();
                    }
                    CS.DOM.$body.offon("click.help-no", "#btn-no", (e) => {
                        $('.help-change-event.hidden').removeClass('hidden');
                        $('#help-buttons').addClass('hidden');
                        $('#cs-event-dropdown-event-drpdwn-help').click();
                    });
                    CS.DOM.$body.offon("click.eventDropdownItemClickedHelp", "#dropdown-event-drpdwn-help .list-item", (e) => {
                        const $item = $(e.currentTarget);
                        const id = $item.data("value");
                        const url = $item.data("extravalues").url;
                        CS.Nav.Go(url + "&eventId=" + id);
                    });
                    CS.DOM.$body.offon("click.eventDropdownAutocompleteItemClickedHelp", "#dropdown-autocomplete-find-events-event-drpdwn-help .list-item", (e) => {
                        const $item = $(e.currentTarget);
                        const id = $item.data("value");
                        const $customUrlInput = $("#AutocompleteEventsCustomUrl");
                        if ($customUrlInput.length) {
                            const url = $customUrlInput.val();
                            CS.Nav.Go(url + "&eventId=" + id);
                        }
                        else {
                            console.error("Hidden input #AutocompleteEventsCustomUrl was not found.");
                        }
                    });
                }
            }
            Views.PageContext.OnPageLoaded({ actionName: "selecteventforhelp", controllerName: null }, () => new SelectEventForHelp());
        })(NativeApp = Views.NativeApp || (Views.NativeApp = {}));
    })(Views = CS.Views || (CS.Views = {}));
})(CS || (CS = {}));

//# sourceMappingURL=general.contactus.js.map
